import {
  Ref,
} from 'vue';
import { HekateDisplayForm } from 'www-shared';
import UnifiedSignupScreenComponent from '../UnifiedSignupScreenComponent';
import UnifiedSignupScreenName from '../UnifiedSignupScreenName';
import UnifiedSignupSessionInfo from '../session-info/UnifiedSignupSessionInfo';
import AbstractSignupScreen from './AbstractSignupScreen';

export default class SignupSubmittingSignupScreen extends AbstractSignupScreen {
  public screenName: UnifiedSignupScreenName = 'uss-signup-form-submitting';

  private readonly onUpdatePage: VoidFunction;

  private readonly isNextButtonHidden: Ref<boolean>;

  constructor({
    sessionInfo,
    formDefinition,
    onUpdatePage,
    isBackButtonHidden,
    isNextButtonHidden,
  }: {
    sessionInfo: Ref<UnifiedSignupSessionInfo>,
    formDefinition: Ref<HekateDisplayForm>,
    onUpdatePage: VoidFunction,
    isBackButtonHidden: Ref<boolean>,
    isNextButtonHidden: Ref<boolean>,
  }) {
    super({ sessionInfo, formDefinition, isBackButtonHidden });
    this.onUpdatePage = onUpdatePage;
    this.isNextButtonHidden = isNextButtonHidden;
  }

  // eslint-disable-next-line class-methods-use-this
  public getVisibleComponents(): UnifiedSignupScreenComponent[] {
    return [];
  }

  public getValidatedComponents(): UnifiedSignupScreenComponent[] {
    return this.getVisibleComponents();
  }

  // eslint-disable-next-line class-methods-use-this
  public getProgress(): number {
    return 90;
  }

  public predicate(): boolean {
    return this.sessionInfo.value.formSubmitStatus === 'submitting';
  }

  // eslint-disable-next-line class-methods-use-this
  public async toNextScreen(): Promise<boolean> {
    await this.pollFormSubmitting();
    return true;
  }

  public async initWatchers(): Promise<void> {
    this.onUpdatePage();
  }

  private async pollFormSubmitting() {
    await new Promise((res) => {
      const interval = setInterval(() => {
        const { formSubmitStatus } = this.sessionInfo.value;
        // eslint-disable-next-line no-console
        console.log('Polling Submission:', formSubmitStatus);
        if (formSubmitStatus === 'submitted' || formSubmitStatus === 'submit-failed') {
          clearInterval(interval);
          res(null);
        }
      }, 1000);
    });
  }
}
